<button class="btn btn-sm btn-link text-dark"
        [ngClass]="{'invisible': isInvisible}"
        [disabled]="isInvisible"
        (click)="isOpen = !isOpen">
  <span class="fa-solid"
        [ngClass]="{'fa-chevron-right': !isOpen, 'fa-chevron-down': isOpen}">
  </span>
</button>
